import * as msg from '../../../../../node_modules/console-tags.js/src/console-tags.js'
import { showSlider} from '../../components/carousels'
import { showMap, indexMap } from '../../components/maps'
require('@fancyapps/fancybox')

const init = () => {
    showSlider()
    showMap()
}

export default init
